<template>
  <div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button class="btn iconed btn-secondary" v-b-modal.problem-Detail><i
              class="icon-bd-plus"></i><span>جدید</span></button>
          </div>
        </div>
      </div>
      <div class="col-lg-12 p-0">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">عملیات</th>
            <th scope="col" class="text-center">ردیف</th>
            <th scope="col" class="text-center">نوع مشکل</th>
            <th scope="col" class="text-center">نام مشکل</th>
            <th scope="col" class="text-center">توضیحات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) of problemDetails">
            <td class="text-center">
              <button :id="'btn-problem-' + item.id" class="btn btn-secondary ml-2"
                      @click="editProblemDetailRow(item, index)"
                      data-toggle="tooltip"><i class="icon-bd-pencil"></i>
              </button>
              <button :id="'btn-delete-' + item.id" class="btn btn-secondary"
                      @click="onDeleteClicked(item, index)"><i class="icon-bd-delete"></i></button>
            </td>
            <th scope="row" class="text-center">{{index + 1}}</th>
            <td class="text-center">{{item.workProblemTypeName}}</td>
            <td class="text-center">{{item.name}}</td>
            <td class="text-center">{{item.description}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id="problem-Detail"
      ref="problemDetailModal"
      title="تعریف نوع مشکل"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="نوع مشکل"
          label-for="name-input"
          invalid-feedback="نوع مشکل الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="problemType.name"
            :state="typeState"
            required
            readonly
          ></b-form-input>
        </b-form-group>
      </form>

      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="نام مشکل"
          label-for="name-input"
          invalid-feedback="نام الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="name"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="توضیحات"
          label-for="name-input"
          invalid-feedback="توضیحات الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="description"
            :state="descriptionState"
            required
          ></b-form-input>
        </b-form-group>
      </form>

    </b-modal>
  </div>
</template>

<script>
    import VsTable from "../_framework/VsTable.vue";
    import ShowProblemsModal from "../components/ShowProblemsModal";
    import BaseService from "../_framework/api/BaseService.js";
    import {mapState} from "vuex";

    export default {
        name: "problem-details",
        components: {
            VsTable,
            ShowProblemsModal
        },
        props: {
            problemType: Object
        },
        data() {
            return {
                access: {},
                problemDetails: [],
                deleteButtonState: 'primary',
                data: '',
                submittedNames: [],
                submittedDescription: [],
                nameState: null,
                name: '',
                type: '',
                typeState: null,
                description: '',
                descriptionState: null,
                editProblemDetailFlag: false,
                problemDetailRow: {},
                problem: {
                    name: '',
                    description: '',
                    workProblemTypeId: 0
                }
            };
        },
        mounted() {
            this.getProblems();
        },
        methods: {

            getProblems() {
                new BaseService('WorkProblems', `/GetProblemsByTypeId/${this.problemType.id}`).getList().then((response) => {
                    // console.log(response.data);
                    this.problemDetails = response.data;
                }).catch((error) => {
                    console.log(error)
                })
            },
            onDeleteClicked(item) {
                const $btnDel = $(`#btn-delete-${item.id}`);
                if (!$btnDel.hasClass("btn-danger")) {
                    $btnDel.addClass("btn-danger");
                    setTimeout(() => {
                        $btnDel.removeClass("btn-danger");
                    }, 2000);
                } else {
                    new BaseService('WorkProblems', `/DeleteProblem/${item.id}`).delete().then((response) => {
                        this.$noty.success("حذف با موفقیت انجام شد");
                        this.getProblems();
                    }).catch((error) => {
                        console.log(error)
                    });
                }
            },
            createProblem(item) {
                let createProblem = {
                    name: item.name,
                    description: item.description,
                    workProblemTypeId: item.workProblemTypeId
                };
                new BaseService('WorkProblems', '/CreateProblem').create(createProblem).then((response) => {
                    this.$noty.success("ثبت با موفقیت انجام شد");
                    this.getProblems();
                }).catch((error) => {
                    console.log(error)
                });
            },
            updateProblemType(obj) {
                let updateProblemType = {
                    id: this.problemDetailRow.id,
                    name: obj.name,
                    description: obj.description,
                    workProblemTypeId: this.problemType.id
                };

                new BaseService('WorkProblems', '/UpdateProblem').update(updateProblemType).then((response) => {
                    this.$noty.success("تغییرات با موفقیت صورت گرفت");
                    this.getProblems();
                    this.editProblemDetailFlag = false;
                }).catch((error) => {
                    console.log(error)
                });
            },
            onShowProblemItems(item) {
                this.$refs['problemTypeDetail'].show();
                console.log(item)
            },
            editProblemDetailRow(item, index) {
                this.editProblemDetailFlag = true;
                this.$refs['problemDetailModal'].show();
                this.name = item.name;
                this.description = item.description;
                this.problemDetailRow = item
            },
            onCancelClicked() {

            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity();
                this.nameState = valid ? 'valid' : 'invalid';
                this.descriptionState = valid ? 'valid' : 'invalid';
                return valid
            },
            handleSubmit() {
                // Exit when the form isn't valid
                if (!this.checkFormValidity()) {
                    return
                }
                // Push the name to submitted names
                this.submittedNames.push(this.name);
                this.submittedDescription.push(this.description)
                // Hide the modal manually
                this.$nextTick(() => {
                    this.$refs.problemDetailModal.hide()
                    this.editProblemDetailFlag = false
                })
            },
            handleOk(bvModalEvt) {
                let problemModel = {
                    name: this.name,
                    description: this.description,
                    workProblemTypeId: this.problemType.id
                }
                // Prevent modal from closing
                bvModalEvt.preventDefault();
                // Trigger submit handler
                this.handleSubmit();

                if (this.editProblemDetailFlag === false && problemModel.name) {
                    this.createProblem(problemModel)
                    // console.log(problemModel)
                } else if (this.editProblemDetailFlag === true && problemModel.name){
                    this.updateProblemType(problemModel);
                }
            },
            resetModal() {
                this.name = '';
                this.nameState = null;
                this.description = '';
                this.descriptionState = null;
                this.type = '';
                this.typeState = null;
            },


        },
        created: () => {
        },
        /*beforeMount() {
            this.options.access = checkAccess(this.$route.path);
            //console.log(this.options.access);
            this.show = !!this.options.access;
        },*/
        computed: {
            ...mapState(["selectedRows", "currentService", "vsTableFeed"]),

        }
    };
</script>



